import React from "react";
import { Container, Row, Col } from "reactstrap";
import banner_video from "../../assets/banners/video-bg.mp4";
import poster from "../../assets/banners/machina-bg-3.jpg";

import logo1 from "../../assets/images/Logo Files/lyon.png";
import logo2 from "../../assets/images/Logo Files/insa.png";
import logo3 from "../../assets/images/Logo Files/liris.png";
import logo4 from "../../assets/images/Logo Files/europe.jpg";

const HeaderBanner = () => {
  return (
    <div id="videoWrapper" className="banner1">
      <div id="fullScreenDiv">
        <img id="video" src={poster} />

        <div id="fullScreenDiv-1">
          <div className="overlay justify-content-center">
            <Col md="12" className="align-self-left ">
              <h1 className="title">Journée MACHINA</h1>

              <h4 className="subtitle font-light">
                {/* <br /> */}
                <strong>Compétences en Machine Learning pour les professionnels en TIC</strong>
              </h4>

              <h5 className="subtitle">
                22 nov. 2022 10:00 AM Paris (par visio)
                <br />
                Lien :{" "}
                <a
                  href="https://univ-lyon1-fr.zoom.us/j/89044275917"
                  target="_blank"
                  className="link"
                >
                  {" "}
                  https://univ-lyon1-fr.zoom.us/j/89044275917{" "}
                </a>
                <br />
                <br />
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSf9vYlFiu4kfbB3T7SlyJDKe1LHOzPYNJDmlrJL0Fpz_0C0og/viewform"
                  target="_blank"
                  className="link"
                >
                  {" "}
                  Inscrivez-vous{" "}
                </a>{" "}
                pour participer à l'événement
              </h5>

              {/* <Col md="12" className="align-self-left "></Col> */}

             
            </Col>
          </div>
        </div>

        <Row className="center" id="logos">
          <Col lg="3" md="6" className="m-b-30" align="center">
            <img id="europe_1" src={logo4} />
          </Col>
          <Col lg="3" md="6" className="m-b-30" align="center">
            <img id="lyon" src={logo1} />
          </Col>
          <Col lg="3" md="6" className="m-b-30" align="center">
            <img id="insa" src={logo2} />
          </Col>
          <Col lg="3" md="6" className="m-b-30" align="center">
            <img id="liris" src={logo3} />
          </Col>
        </Row>

        {/* <Container id="logos">
          <Row className="center">
            <Col lg="3" md="6" className="m-b-30" align="center">
              <img id="liris" src={logo4} />
            </Col>
            <Col lg="3" md="6" className="m-b-30" align="center">
              <img id="lyon" src={logo1} />
            </Col>
            <Col lg="3" md="6" className="m-b-30" align="center">
              <img id="insa" src={logo2} />
            </Col>
            <Col lg="3" md="6" className="m-b-30" align="center">
              <img id="liris" src={logo3} />
            </Col>
          </Row>
        </Container> */}
      </div>
    </div>
  );
};

export default HeaderBanner;
